import {
  Achievement,
  TransformedAchievement,
} from '@osmosis/shared/types/achievement';
import { AchievementType } from '@osmosis/shared/types/achievement';
import { AxiosPostType } from '../../../context/FetchProvider';

/**
 * Retrieves achievements by type.
 */
export const getAchievementsByType = async (
  post: AxiosPostType,
  type: AchievementType,
  mediaNodeID?: number,
): Promise<TransformedAchievement[]> => {
  const { data } = (await post('/achievement', {
    type,
    mediaNodeID,
  })) as { data: { achievements: Achievement[] } };

  if (data?.achievements) {
    return data.achievements.map(({ data, ...restData }) => {
      // The server returns an Achievement shape where `data` holds the
      // transformed achievement fields. Merge them into a TransformedAchievement
      const merged = {
        ...restData,
        ...(data as unknown as Record<string, unknown>),
      } as unknown as TransformedAchievement & {
        count?: number;
        isInitial?: boolean;
        nextAchievement?: { threshold?: number } | null;
        earned?: unknown;
      };

      // Compute `earned` locally from available fields. The server no longer
      // attaches an `earned` flag so we infer it from isInitial or count vs
      // the nextAchievement threshold.
      const threshold = merged.nextAchievement?.threshold ?? 0;
      const earnedFromCount = (merged.count ?? 0) >= threshold && threshold > 0;
      const earned = Boolean(merged.isInitial || earnedFromCount);

      return {
        ...merged,
        earned,
      } as TransformedAchievement;
    });
  }
  return [];
};
